import { BeneficiarioPagamento } from './beneficiario-pagamento';

export class BeneficiarioPagamentoArray {
  beneficiarioPagamento: BeneficiarioPagamento;
  id: string;
}
